import React from 'react';
import styled from 'styled-components';
import { getImage } from 'gatsby-plugin-image';
import PropTypes from 'prop-types';
import {
  CTAMultiCard
} from '@comicrelief/component-library';
import renderRichText from '../RichText/RichText';
import isInternalUrl from '../../utils/isInternalUrl';
import { paddingOptionMapping } from '../../utils/optionMapping';
import ImagePropType from '../../commonPropTypes/commonPropTypes';

const Wrapper = styled.div`
  overflow: hidden;
`;

const CTAMultiCardWrapper = ({ data }) => {
  const {
    cards,
    backgroundColour: bgCards,
    layout,
    paddingAbove,
    paddingBelow
  } = data;

  if (!cards || !Array.isArray(cards) || cards.length === 0) {
    return null;
  }

  const processedCards = cards.map((card) => {
    const {
      body: cardBody,
      id,
      image,
      link,
      linkLabel
    } = card;

    const thisImageData = getImage(image);
    const thisImageFallback = thisImageData?.images?.fallback?.src;
    const thisImageLow = thisImageData?.placeholder?.fallback;
    const thisImageSrcSet = thisImageData?.images?.sources[0]?.srcSet;
    const thisImageDesc = image?.description ?? '';
    const isInternalLink = link && isInternalUrl(link);
    const target = isInternalLink ? 'self' : 'blank';
    const external = target === 'blank' ? 'noopener' : null;

    const renderedBody = cardBody ? renderRichText(cardBody, 'white', 'card') : null;

    return {
      id,
      body: renderedBody,
      image,
      link,
      linkLabel,
      fallback: thisImageFallback,
      imageLow: thisImageLow,
      images: thisImageSrcSet,
      description: thisImageDesc,
      isInternalLink,
      target,
      external
    };
  });

  // Contentful provides padding options as labels (e.g. "0px (0rem)"),
  const mapPaddingValue = value => paddingOptionMapping[value] || value;

  const processedData = {
    cards: processedCards,
    backgroundColour: bgCards,
    layout,
    // Hardcoding this (see ENG-4958) as we've removed the option from the CMS:
    carouselOfCards: true,
    paddingAbove: paddingAbove ? mapPaddingValue(paddingAbove) : '2rem',
    paddingBelow: paddingBelow ? mapPaddingValue(paddingBelow) : '2rem'
  };

  return (
    <Wrapper>
      <CTAMultiCard data={processedData} />
    </Wrapper>
  );
};

CTAMultiCardWrapper.propTypes = {
  data: PropTypes.shape({
    cards: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string.isRequired,
        body: PropTypes.shape({
          raw: PropTypes.string
        }),
        image: ImagePropType,
        link: PropTypes.string,
        linkLabel: PropTypes.string
      })
    ).isRequired,
    backgroundColour: PropTypes.string,
    layout: PropTypes.string,
    paddingAbove: PropTypes.string,
    paddingBelow: PropTypes.string
  }).isRequired
};

export default CTAMultiCardWrapper;
